import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../../services';
import { environment } from './../../../environments/environment';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { DialogService } from '../../services/dialog/dialog.service';
import { ChangePasswordChallengeComponent } from '../change-password-challenge/change-password-challenge.component';
import { COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION, COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION, COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION, COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION, PATTERN_EMAIL } from '../../utils/constant';
import { LanguageService } from 'src/app/services/language/language.service';
import { LoginService } from 'src/app/auth/login/login.service'
import * as _ from 'lodash';
import { NoWhiteSpaceValidator } from '../../utils/validators/nowhitespace.validator';
import { PrivacyNoticeDialogComponent } from 'src/app/services/dialog/privacy-notice-dialog/privacy-notice-dialog.component';


@Component({
  selector: 'esc-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public isPasswordShown: boolean;
  public isSubmitting : boolean;
  public loginForm : UntypedFormGroup;
  public errorMessage: String;

  constructor(
    private fb: UntypedFormBuilder, 
    private route: ActivatedRoute, 
    private dialogService: DialogService,
    private router: Router, 
    public authService: AuthService,
    private loginService: LoginService,
    private languageService: LanguageService,
  ) { }
  
  ngOnInit() {

    this.loginForm = this.fb.group({
      username: [null, [Validators.required, NoWhiteSpaceValidator, Validators.pattern(PATTERN_EMAIL)]],
      password: [null, Validators.required],
      rememberMe: [false]
    });

    console.log("INSTANCE: ",environment.instance)

    this.route.queryParams.subscribe(params => {
      if(params['username']){
        this.loginForm.controls['username'].setValue(params['username']);
      }
    });
    
  }

  onSubmit(value: any){
 
    this.isSubmitting = true;
    this.loginForm.disable();


    let authenticationDetails = new AuthenticationDetails({
      Username: _.trim(value.username),
      Password: value.password
    });
    
    let cognitoUser = new CognitoUser({
      Username : _.trim(value.username),
      Pool : this.authService.userPool      
    });
    
    let self = this;
    

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: async function (session) {
        await self.authService.initAWSCredentials();
        self.loginService.requestUserData()
          .subscribe(res => {
          // console.log("getUser", res)
            if (res && res.success?.count > 0) {
              self.authService.setUserData(res.success.results.user_details)
              self.authService.setUserSettings(res.success.results.settings)

              // enables and disabled add box for certain countries
              // determined by host
              if (res.success.results?.is_addbox_allowed_to_ofw_country) {
                self.authService.setCountryIsAllowed(true)
              } else {
                self.authService.setCountryIsAllowed(false)
              }
              
              self.router.navigate(['/']);
            }
        });
        
      },
      onFailure: function (err) {
        self.isSubmitting = false;
        self.loginForm.enable();

        switch(err.name){
          case COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION:
          case COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION:
            self.errorMessage = self.languageService.getTranslation("MESSAGE_ERROR_USERNAME_PASSWORD_INCORRECT",{});
            break;
          case COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION:
            self.errorMessage = self.languageService.getTranslation("MESSAGE_ERROR_USERNAME_PASSWORD_INCORRECT",{});
            break;
          case COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION:
            self.errorMessage = self.languageService.getTranslation("FORM_ERROR_VERIFY_ACCOUNT",{});
            break;
          default: 
          self.errorMessage = self.languageService.getTranslation("FORM_ERROR_DEFAULT",{});
            
        }
      },
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        self.isSubmitting = false;
        delete userAttributes.email_verified;
        delete userAttributes.email;
        self.dialogService.openDialog(ChangePasswordChallengeComponent, { 
            width: "400px", 
            autoFocus: true,  
            disableClose: true, 
            data: {
              session: this
            }
          })
          .afterClosed()
          .subscribe((password) => {
            self.isSubmitting = true;
            cognitoUser.completeNewPasswordChallenge(password, userAttributes, this);
          });
      }
    })
  }

  onSignUp() {
    this.dialogService.openDialog(PrivacyNoticeDialogComponent).afterClosed().subscribe(res => {
      if (res) {
        this.router.navigate(['/register'])
      }
    })
  }

}
